// extracted by mini-css-extract-plugin
export default {"filters":"StoppingAreasScreen_filters__lRYSI"};